var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _path5, _path6, _path7, _linearGradient5, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q7XamDf1hnh~bz~vAO7C6a",
    x1: 28,
    x2: 28,
    y1: 14.966,
    y2: 6.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#42a3f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42a4eb"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q7XamDf1hnh~bz~vAO7C6a)",
    d: "M42,6H14c-1.105,0-2,0.895-2,2v7.003h32V8C44,6.895,43.105,6,42,6z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q7XamDf1hnh~bz~vAO7C6b",
    x1: 28,
    x2: 28,
    y1: 42,
    y2: 33.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#11408a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#103f8f"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q7XamDf1hnh~bz~vAO7C6b)",
    d: "M12,33.054V40c0,1.105,0.895,2,2,2h28c1.105,0,2-0.895,2-2v-6.946H12z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q7XamDf1hnh~bz~vAO7C6c",
    x1: 28,
    x2: 28,
    y1: -15.46,
    y2: -15.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q7XamDf1hnh~bz~vAO7C6c)",
    d: "M12,15.003h32v9.002H12V15.003z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q7XamDf1hnh~bz~vAO7C6d",
    x1: 12,
    x2: 44,
    y1: 28.53,
    y2: 28.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d59b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195bbc"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q7XamDf1hnh~bz~vAO7C6d)",
    d: "M12,24.005h32v9.05H12V24.005z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.319,13H12v24h10.319C24.352,37,26,35.352,26,33.319V16.681C26,14.648,24.352,13,22.319,13z",
    opacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.213,36H12V13.333h10.213c1.724,0,3.121,1.397,3.121,3.121v16.425 C25.333,34.603,23.936,36,22.213,36z",
    opacity: 0.07
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.106,35H12V13.667h10.106c1.414,0,2.56,1.146,2.56,2.56V32.44C24.667,33.854,23.52,35,22.106,35z",
    opacity: 0.09
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q7XamDf1hnh~bz~vAO7C6e",
    x1: 4.744,
    x2: 23.494,
    y1: 14.744,
    y2: 33.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#256ac2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1247ad"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q7XamDf1hnh~bz~vAO7C6e)",
    d: "M22,34H6c-1.105,0-2-0.895-2-2V16c0-1.105,0.895-2,2-2h16c1.105,0,2,0.895,2,2v16 C24,33.105,23.105,34,22,34z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.403,19l-1.546,7.264L15.144,19h-2.187l-1.767,7.489L9.597,19H7.641l2.344,10h2.352l1.713-7.689 L15.764,29h2.251l2.344-10H18.403z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.cf6e656f8830c1024fe285ab813c10c4.svg";
export { ForwardRef as ReactComponent };